import { useState } from 'react';
import {
  IconDroplet,
  IconLeaf,
  IconCloudRain,
  IconBox,
  IconAlertTriangle,
  IconTool,
  IconChevronDown,
} from '@tabler/icons-react';
import { useSiteContent } from '../context/SiteContentContext';
import GuyanaStripe from '../components/layout/GuyanaStripe';
import PageTitle from '../components/ui/PageTitle';
import './CareGuidePage.css';

var careIcons = [IconDroplet, IconLeaf, IconCloudRain, IconBox];

export default function CareGuidePage() {
  var content = useSiteContent();
  var c = content.c;
  var _openFaq = useState(null);
  var openFaq = _openFaq[0];
  var setOpenFaq = _openFaq[1];

  var careCards = [1,2,3,4].map(function(n) {
    return {
      title: c('care_' + n + '_title'),
      frequency: c('care_' + n + '_frequency'),
      body: c('care_' + n + '_body'),
      Icon: careIcons[n - 1],
    };
  });

  var warnings = c('care_warning', '').split('|').filter(Boolean);

  var faqs = [1,2,3,4].map(function(n) {
    return { q: c('care_faq_' + n + '_q'), a: c('care_faq_' + n + '_a') };
  }).filter(function(f) { return f.q; });

  return (
    <>
      <PageTitle title="Care Guide" />
      <section className="care-hero page-band">
        <h1 className="care-hero__headline page-band__title">{c('care_heading')}</h1>
      </section>

      <GuyanaStripe />

      <section className="container care-grid">
        {careCards.map(function(card, i) {
          return (
            <div className="care-card" key={i}>
              <div className="care-card__icon"><card.Icon size={20} /></div>
              <span className="care-card__freq">{card.frequency}</span>
              <h3 className="care-card__title">{card.title}</h3>
              <p className="care-card__body">{card.body}</p>
            </div>
          );
        })}
      </section>

      <div className="container container--reading care-reading">
      <section className="care-warning">
        <div className="care-warning__icon"><IconAlertTriangle size={18} /></div>
        <h3 className="care-warning__title">What to avoid</h3>
        <ul className="care-warning__list">
          {warnings.map(function(w, i) { return <li key={i}>{w}</li>; })}
        </ul>
      </section>

      <section className="care-repair">
        <div className="care-repair__icon"><IconTool size={18} /></div>
        <h3 className="care-repair__title">Need a repair?</h3>
        <p className="care-repair__body">
          {'Every bag comes with a lifetime craftsmanship guarantee. If a seam fails or hardware breaks under normal use, I\u2019ll repair or replace it at no cost. For wear-and-tear repairs beyond the guarantee, I offer repairs at cost.'}
        </p>
      </section>

      {faqs.length > 0 && (
        <section className="care-faq">
          <h2 className="care-faq__heading">Common questions</h2>
          {faqs.map(function(faq, i) {
            var isOpen = openFaq === i;
            return (
              <div className={'care-faq__item' + (isOpen ? ' care-faq__item--open' : '')} key={i}>
                <button className="care-faq__question" onClick={function() { setOpenFaq(isOpen ? null : i); }}>
                  <span>{faq.q}</span>
                  <IconChevronDown size={16} className="care-faq__chevron" />
                </button>
                {isOpen && <p className="care-faq__answer">{faq.a}</p>}
              </div>
            );
          })}
        </section>
      )}
      </div>
    </>
  );
}